import React from 'react';
import { EarlierIndexWrapper, IndexWrapper } from './styled';

const EarlierOrder = ({ policy, idx, order, originalOrder }) => {
  const policyIndexBeforeOrderChange =
    order.indexOf(policy.id) !== originalOrder.indexOf(policy.id)
      ? originalOrder.indexOf(policy.id) + 1
      : null;

  return (
    <div style={{ marginRight: '10px', display: 'flex' }}>
      <IndexWrapper>{idx}</IndexWrapper>
      {policyIndexBeforeOrderChange ? (
        <EarlierIndexWrapper>{`Earlier ${policyIndexBeforeOrderChange}`}</EarlierIndexWrapper>
      ) : (
        ''
      )}
    </div>
  );
};

export default EarlierOrder;
